import Swiper from "swiper";
import { Autoplay } from "swiper";


const slider = document.querySelector('.mySwiperValidated');
const sliderWrapper = slider.querySelector(".swiper-wrapper");
let sliderItems = slider.querySelectorAll(".swiper-slide");

if (sliderWrapper && sliderItems.length > 0) {
    let slidesCount = sliderItems.length;

    if (slidesCount <= 8) {
        let repeat = Math.ceil((8 / slidesCount) * 2);
        if (repeat > 0) {
            for (let i = 0; i < repeat; i++) {
                sliderItems.forEach((item) => {
                    const swiperItemNew = document.createElement("div");
                    swiperItemNew.classList.add("swiper-slide");
                    swiperItemNew.innerHTML = item.innerHTML;
                    sliderWrapper.append(swiperItemNew);
                });
            }
        }
    }

    new Swiper(slider, {
        modules: [Autoplay],
        spaceBetween: 88,
        loop: true,
        slidesPerView: "auto",
        speed: 6000,
        allowTouchMove: false,
        autoplay: {
            delay: 0,
            disableOnInteraction: false,
        },
    });

}
